import { useContext } from "react";
import { GlobalContext } from "./ContextProvider";
import UserDao from "../../dao/UserDao";
/**
 * A collection of context setters
 */

/**
 * SchoolYearPerformance "getter" flag
 * @type {boolean}
 */
let getSY = true;

/**
 * Get the schoolYearDto and set it in context
 * @name SetSchoolYearDto
 * @constructor
 */
export const SetSchoolYearDto = () => {
    const { dispatch, state } = useContext(GlobalContext);
    const { schoolYearDto, token } = state || {};

    if (token && !schoolYearDto) {
        if (getSY) {
            getSY = false;
            const options = {
                action: "activeSchoolYearRead",
                token
            };
            UserDao(options)
                .then((response) => {
                    if (response) {
                        const { payload } = response.data;
                        if (Object.keys(payload).length) {
                            dispatch({
                                type: "SchoolYearDto",
                                schoolYearDto: payload
                            });
                        }
                        getSY = true;
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }
};
